import { Components, Theme } from '@mui/material'

export const MuiTab: Components<Omit<Theme, 'components'>>['MuiTab'] = {
  defaultProps: {
    disableRipple: true,
    iconPosition: 'start',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: 48,
      maxHeight: 48,
      padding: theme.spacing(0, 1.5),
      ...theme.typography.HeaderSubtitleMediumMedium,
      textTransform: 'none',
      color: theme.palette.neutralLight[900],
      '&.Mui-selected': {
        color: theme.palette.text.primary,
      },
      whiteSpace: 'nowrap',
      minWidth: 'auto',
      position: 'relative',
    }),
  },
}
